export default "__VITE_ASSET__DGJsAS8L__"